import { FeatureConfigAttributesBase } from './FeatureConfigAttributesBase';

export enum SmartFleetType {
    ONDEMAND = 'ONDEMAND',
    DEDICATED = 'DEDICATED',
}
export interface SmartFleetChoiceEntry {
    id: number;
    type: SmartFleetType;
}

export interface SmartFleetChoiceAttributes extends FeatureConfigAttributesBase {
    fleets: Array<SmartFleetChoiceEntry>;
    customJSLogic: string;
}
